import { useContext, createContext } from "react";
export var useThemeContext = function () { return useContext(ThemeContext); };
export var ThemeContext = createContext({});
